import { baseUrl } from "../../../../boot";
import axios from "axios";

// Add client
export const addClient = async (formData) => {
  console.log("client form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/create-contact`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// delete client  API
export const deleteClient = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}crm/api/v1/delete-contact/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// update clients
export const updateClient = async (ROWID, data) => {
  console.log("c",data)
  // const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}crm/api/v1/update-contact/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// total count
export const countClient = async (formData) => {
  console.log(formData,"count")
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}crm/api/v1/get-contact-count`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

export const getClientDetailById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}crm/api/v1/get-contact-by-id/${id}`, {
      headers: {
        "auth-token": token,
      }
    })
    // console.log('<<<<<<<<<<<<<<<<<<<<<companires>>>>>>>>>>>>>>>>>',response)
    return response
  } catch (error) {
    throw error
  }
}


// Add client
export const getClientRelatedTasks = async (formData) => {
  console.log("client form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-task-by-contactID`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// Add client
export const getClientRelatedNotes = async (formData) => {
  console.log("client form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-note-by-contactID`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// Add client
export const getClientRelatedDeal = async (formData) => {
  console.log("client form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-deal-by-contactID`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
export const IsClientExistWithPhone = async (phone) => {
  console.log("client phone data ---- ", phone); 
    const token = localStorage.getItem("authToken")
   try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-contact-by-phone`, phone, {
      headers: {
       'Content-Type': 'application/json',
      }
    },)
    
    return response.data;
  } catch (error) {
    throw error
  }
}


//Zoho Books API

export const addClientinZohoBooks = async (Id) => {
  console.log("zoho books client form id ---- ", Id);
  // const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}zohoBooks/api/v1/contacts/${Id}`, {
      // headers: {
      //   "auth-token": token,
      // }
    },)
    console.log("zoho boooks response",response)
    return response;
  } catch (error) {
    throw error
  }
}

export const updateClientinZohoBooks = async (ROWID, data) => {
  console.log("c",data)
  // const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}zohoBooks/api/v1/contacts/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

export const deleteClientinZohoBooks = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}/zohoBooks/api/v1/contacts/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}